const globalAttributes = {
    companyName: 'CodeUI',
    websiteLink: "https://codeui.co.in/"
}   


export default globalAttributes